// User-tunable customer settings — persists per browser via localStorage.

import { createSlice } from "@reduxjs/toolkit";

const KEY_KW = "ssc_installed_kw";

const initialKw = (() => {
  const raw = localStorage.getItem(KEY_KW);
  const n = raw == null ? 50 : Number(raw);
  return Number.isFinite(n) && n > 0 ? n : 50;
})();

const initialState = {
  installedKw: initialKw,
};

const slice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setInstalledKw(state, { payload }) {
      const n = Number(payload);
      if (Number.isFinite(n) && n > 0) {
        state.installedKw = n;
        try { localStorage.setItem(KEY_KW, String(n)); } catch {}
      }
    },
  },
});

export const { setInstalledKw } = slice.actions;
export default slice.reducer;
